import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Linkedin, Instagram, Youtube, FileText } from 'lucide-react';

const Footer = () => {
  const handleBrochureDownload = () => {
    // Mock download - replace with actual PDF URL when ready
    console.log('Downloading brochure...');
    // window.open('/path/to/brochure.pdf', '_blank');
  };

  return (
    <footer className="glass-frosted border-t" className="border-subtle">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div>
                <div className="text-foreground-primary font-bold text-xl md:text-2xl leading-tight">Vinayak Robotics</div>
              </div>
            </div>
            <p className="text-sm text-foreground-secondary">
              Intelligent Machines. Infinite Possibilities.
            </p>
            <div className="flex gap-4 mt-4">
              <a
                href="https://www.linkedin.com/company/vinayakrobotics/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-smooth hover:scale-110 text-foreground-secondary hover:text-accent"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a 
                href="https://www.instagram.com/vinayak_robotics/"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-smooth hover:scale-110 text-foreground-secondary hover:text-accent"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.youtube.com/@vinayakrobotics"
                target="_blank"
                rel="noopener noreferrer"
                className="transition-smooth hover:scale-110 text-foreground-secondary hover:text-accent"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-foreground-primary font-semibold mb-4">Products</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/vulcan" className="text-sm text-foreground-secondary hover:text-accent transition-smooth">
                  Vulcan Series
                </Link>
              </li>
              <li>
                <Link to="/astra" className="text-sm text-foreground-secondary hover:text-accent transition-smooth">
                  Astra Series
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-foreground-primary font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-foreground-secondary">
                <Mail size={18} className="flex-shrink-0" style={{ color: '#F97316' }} />
                <a
                  href="mailto:contact@vinayakrobotics.com?subject=Inquiry%20from%20Website"
                  className="hover:text-accent transition-colors"
                >
                  contact@vinayakrobotics.com
                </a>
              </li>

              <li className="flex items-center gap-3 text-sm text-foreground-secondary">
                <Phone size={18} className="flex-shrink-0" style={{ color: '#F97316' }} />
                <a
                  href="tel:+913348127214"
                  className="hover:text-accent transition-colors"
                >
                  +91 33 4812 7214
                </a>
              </li>
            </ul>
          </div>

          {/* Brochure Download */}
          <div>
            <h3 className="text-foreground-primary font-semibold mb-4">Resources</h3>
            <button
              onClick={handleBrochureDownload}
              className="glass-effect rounded-xl p-4 w-full transition-smooth hover:scale-105 group border border-orange-500/30 hover:border-orange-500/60"
              style={{
                boxShadow: '0 4px 20px rgba(249, 115, 22, 0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(249, 115, 22, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(249, 115, 22, 0.1)';
              }}
            >
              <div className="flex items-center gap-3">
                <div 
                  className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 animate-pulse"
                  style={{
                    background: 'rgba(249, 115, 22, 0.1)',
                    border: '1px solid rgba(249, 115, 22, 0.3)',
                  }}
                >
                  <FileText size={24} style={{ color: '#F97316' }} />
                </div>
                <div className="text-left">
                  <div className="text-sm font-semibold text-foreground-primary group-hover:text-accent transition-colors">
                    Get Our Brochure
                  </div>
                  <div className="text-xs text-foreground-secondary">
                    Download PDF
                  </div>
                </div>
              </div>
            </button>
          </div>
        </div>

        <div className="border-t mt-8 pt-8" className="border-subtle">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-foreground-secondary">
              &copy; {new Date().getFullYear()} Vinayak Robotics. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-sm transition-smooth text-foreground-secondary hover:text-accent">
                Privacy Policy
              </a>
              <a href="#" className="text-sm transition-smooth text-foreground-secondary hover:text-accent">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
    );
};

export default Footer;